<template>
  <div id="app">
    <div id="siteTopHeader" class="padding container">
      <nav class="navbar is-transparent">
        <div class="navbar-brand">
          <a class="logo-item" :href="`${baseUrl}/${langPrefix}`">
            <img
              src="/img/logo_seats2meet.svg"
              alt="Seats2meet.com"
              width="100"
              class=""
            />
          </a>
        </div>
      </nav>
    </div>
    <router-view />
    <div class="footer has-background-primary">
      <div class="container">
        <div class="columns">
          <div class="column">
            <a class="has-text-white" :href="`${baseUrl}/${langPrefix}/contact`"
              >> Contact S2M International</a
            >
          </div>
          <div class="column">
            <a class="has-text-white" :href="`${baseUrl}/${langPrefix}/privacy`"
              >> Privacy Policy</a
            >
          </div>
          <div class="column">
            <a class="has-text-white" :href="`${baseUrl}/${langPrefix}/terms`"
              >> Terms</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      baseUrl: process.env.VUE_APP_S2M_BASE_URL,
      langPrefix: this.$route.params.lang || "en",
    };
  },
};
</script>

<style lang="scss">
@import "./assets/styles/main.scss";

#siteTopHeader {
  .navbar {
    background: rgba(white, 0.8);
    padding: 0px;

    .navbar-item {
      font-size: 16px;
      font-weight: 600;
      text-transform: uppercase;

      text-decoration: none;

      span.link-holder {
        position: relative;
        span {
          text-decoration: none;
          &:after {
            transition: left 0.2s, opacity 0.2s, width 0.2s;
            position: absolute;
            content: " ";
            height: 2px;
            background-color: $green;
            width: 10%;
            bottom: -2px;
            left: 50%;
            opacity: 0;
          }

          &:hover:after {
            opacity: 1;
            width: 100%;
            left: 0;
          }

          &.selected:after {
            opacity: 1;
            width: 100%;
            left: 0;
          }
        }
      }
    }
  }
}

.container {
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
}
</style>
